import * as React from 'react';
export const updejeunerSvg = React.forwardRef(function updejeunerSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F49000',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M7.707 8.002v.154a2436.037 2436.037 0 0 0 .019 5.529 658.576 658.576 0 0 0 .008 2.402 154.217 154.217 0 0 0 .004 1.07c-.001.853.025 1.779.642 2.44.509.46 1.158.52 1.825.507.517-.038.996-.144 1.384-.501.634-.746.618-1.703.619-2.628l.002-.277.003-.746.003-.783a1214.293 1214.293 0 0 0 .014-3.163l.015-3.462a613.533 613.533 0 0 1 .91-.205c1.49-.337 1.49-.337 1.77-.337a3013.788 3013.788 0 0 1 .012 6.227 759.803 759.803 0 0 1 .005 2.632 175.441 175.441 0 0 1 .002 1.173c.003.528.002 1.011-.183 1.515-.02.06-.04.122-.059.185a4.35 4.35 0 0 1-2.245 2.472c-.123.054-.247.105-.372.155l-.113.045c-.673.25-1.358.317-2.071.31h-.116c-1.33-.008-2.518-.399-3.486-1.334-.934-.939-1.3-2.225-1.299-3.516l.002-.275v-.299c0-.267.002-.533.003-.8l.002-.84c0-.529.002-1.057.004-1.586a1762.007 1762.007 0 0 1 .016-5.522l.145-.032a3497.245 3497.245 0 0 0 .772-.173l.226-.05.224-.05c.178-.04.356-.081.533-.123l.19-.045.165-.04c.146-.028.277-.035.425-.03Zm11.154 4.663c.14-.086.14-.087.284-.174.35-.201.7-.353 1.083-.478l.157-.053c1.234-.349 2.618-.09 3.744.469 1.356.754 2.269 1.98 2.692 3.447.385 1.407.132 2.959-.59 4.217a6.045 6.045 0 0 1-.862 1.081l-.102.114c-.736.789-1.936 1.336-3.013 1.417-1.255.045-2.334-.126-3.393-.826l-.055 3.524c-.319.105-.625.2-.95.273l-.125.03-.26.058-.394.09-.254.056c-.039.01-.078.018-.118.027-.18.04-.337.063-.524.063V11.85c.533-.131 1.067-.263 1.601-.39l.353-.082.153-.037c.085-.02.17-.042.254-.064.1-.023.101-.022.264-.022l.055 1.41Zm2.582 1.501a2.739 2.739 0 0 0-.644.06c-.816.28-1.42.726-1.865 1.463-.39.724-.55 1.585-.329 2.391l.038.113c.142.444.367.826.655 1.193.498.53 1.182.949 1.922.996.795.026 1.591-.13 2.192-.682l.099-.097c.573-.56.937-1.207.992-2.015.044-1.026-.187-1.801-.884-2.592a3.026 3.026 0 0 0-2.054-.83h-.122Z',
      fill: '#fff',
    }),
  );
});
updejeunerSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var updejeuner = {
  category: 'brand',
  colorable: false,
  name: 'updejeuner',
  svg: updejeunerSvg,
};
